import { Tooltip } from 'antd'
import { MdOpenInNew } from 'react-icons/md'

import { cx } from '@/Ship/Helpers/cssClass'

import type { ReportGroupBy, ReportGroupRow } from '../Contracts/Report'
import { canOpenGroupCard, emptyGroupLabel, groupLabel, openGroupCard } from '../Helpers/reportGroups'

import styles from './Report.module.css'

interface GroupNameProps {
    groupBy: ReportGroupBy
    row: ReportGroupRow
}

/**
 * Назва групи в таблиці звіту: період — відформатована дата, група без значення —
 * приглушене «Без …». Клік по рядку розгортає деталізацію, тож назва — звичайний текст,
 * а картка водія / ТЗ / диспетчера відкривається окремою іконкою праворуч від назви.
 */
export const GroupName = ({ groupBy, row }: GroupNameProps) => {
    const label = groupLabel(groupBy, row)
    if (label === null) return <span className={cx(styles, 'faint')}>{emptyGroupLabel(groupBy)}</span>
    if (!canOpenGroupCard(groupBy, row)) return <>{label}</>

    return (
        <span className={cx(styles, 'name')}>
            {label}
            <Tooltip title="Відкрити картку">
                <button
                    type="button"
                    className={cx(styles, 'cardLink')}
                    aria-label={`Відкрити картку: ${label}`}
                    onClick={(event) => {
                        // Іконка відкриває картку, а не розгортає рядок
                        event.stopPropagation()
                        openGroupCard(groupBy, row)
                    }}
                >
                    <MdOpenInNew />
                </button>
            </Tooltip>
        </span>
    )
}
